/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Royal_Lucky_Fireant_TwistInputs */

const fr_royal_lucky_fireant_twist = /** @type {(inputs: Royal_Lucky_Fireant_TwistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mot de passe doit faire minimum 6 caractères.`)
};

/**

* @param {Royal_Lucky_Fireant_TwistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const royal_lucky_fireant_twist = /** @type {((inputs?: Royal_Lucky_Fireant_TwistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Royal_Lucky_Fireant_TwistInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_royal_lucky_fireant_twist(inputs)
});